import { ReactNode, useEffect } from 'react'
import { Button, Widget } from '@jisr-hr/design-system'
import { Typography, Flex, Spacer } from '@jisr-hr/ds'
import { Form } from 'react-final-form'
// import WidgetWithDrawer from 'containers/authorised/setting/v2/components/WidgetWithDrawer';
import { SwitchField } from 'components/final-form'
import I18n from 'translations/i18n'
import { useDispatch, useSelector } from 'utils/hooks'
import {
  vacationSettlementCalculationLoad,
  vacationSettlementCalculationUpdate,
} from 'redux/organizationOnborading/payrollCalculationConfiguration/actionCreator'
import { organizationInfo } from 'redux/organizationOnborading/organization/actionCreators'
import styles from './../style.module.css'

const CalculationConfiguration = (): JSX.Element => {
  const dispatch = useDispatch()
  const { vacation_review_required, fetching } = useSelector(
    ({ payrollCalculationConfiguration }) => payrollCalculationConfiguration,
  )
  const initialValues = { value: vacation_review_required }
  const handleSubmitConfiguration = (value: { value: boolean }): void => {
    dispatch(vacationSettlementCalculationUpdate(value)).then(() => dispatch(organizationInfo()))
  }

  useEffect(() => {
    dispatch(vacationSettlementCalculationLoad())
  }, [])

  return (
    <Widget
      fetching={fetching}
      title={I18n.t('calculation_configuration')}
    >
      <Form
        initialValues={initialValues}
        onSubmit={handleSubmitConfiguration}
      >
        {({ handleSubmit, pristine }): ReactNode => (
          <form onSubmit={handleSubmit}>
            <Flex justifyBetween>
              <Typography
                variant="title-1"
                text={I18n.t('vacation_settlement_payment_processing')}
              />

              <SwitchField name="value" />
            </Flex>
            <div className={styles.divider} />
            <Spacer height={20} />
            <Flex justifyEnd>
              <Button
                disabled={pristine}
                label={I18n.t('save')}
                type="submit"
                size="medium"
                data-testid="save"
              />
            </Flex>
          </form>
        )}
      </Form>
    </Widget>
  )
}

export default CalculationConfiguration
